import { GeneralSettings } from "./GeneralSettings";
import { MemoriesSettings } from "./MemoriesSettings";

import type { SettingsSection } from "../types";

interface SettingsContentProps {
  section: SettingsSection;
}

export const SettingsContent = ({ section }: SettingsContentProps) => {
  if (section === "general") return <GeneralSettings />;
  if (section === "memories") return <MemoriesSettings />;
  return null;
};
